export const PAGE_EDITOR_HISTORY_TARGET_IDS = {
  header: 'page-slot-header',
  footer: 'page-slot-footer',
} as const;
